import React from 'react'
import { Button, Container, Grid, Image, Segment, TextArea } from 'semantic-ui-react'

import edit from '../../assets/images/edit-small.png'
import openInfo from '../../assets/images/info-fuchsia.png'
import closedInfo from '../../assets/images/info-gray.png'
import Bubble from '../common/bubble'
import Rater from '../common/rater'
import { tr } from '../../helpers/languages'

const Evaluation = (props) => {
    const emotionalState = parseInt(props.session.evaluation ? (props.session.evaluation.emotional_state || 0) : 0, 10)
    const emotionalAwareness =
        parseInt(props.session.evaluation ? (props.session.evaluation.emotional_awareness || 0) : 0, 10)
    const compliance = parseInt(props.session.evaluation ? (props.session.evaluation.compliance || 0) : 0, 10)
    const progress = parseInt(props.session.evaluation ? (props.session.evaluation.progress || 0) : 0, 10)
    const referToPsychiatrist = props.session.evaluation ? props.session.evaluation.refer_to_psychiatrist === true
        : false
    return (
        <Container className='session-evaluation'>
            <Segment className='section-title'>
                {tr('EVALUATION')}
                {
                    !props.editable && (
                        <Image src={edit} onClick={(_e) => { props.onToggleEditing() }}/>
                    )
                }
            </Segment>
            <Grid>
                <Grid.Row columns={2}>
                    <Grid.Column>
                        <Segment className='evaluation-question'>
                            {tr('HOW_WOULD_YOU_RATE_PARTICIPANT_EMOTIONAL_STATE')}
                            {(props.session.attendance.status === 'ontime' || props.session.attendance.status === 'delayed') &&
                            <span className='feelColor'> *</span>}
                        </Segment>
                        <Segment className='evaluation-emotional-state'>
                            <Rater
                                value={emotionalState}
                                onChangeValue={(value) => { props.onChangeValue('evaluation.emotional_state', value.toString()) }}
                                editable={props.editable}
                            />
                        </Segment>
                    </Grid.Column>
                    <Grid.Column>
                        <Segment className='evaluation-question'>
                            {tr('HOW_EMOTIONALLY_AWARE_IS_THE_PARTICIPANT')}
                            {(props.session.attendance.status === 'ontime' || props.session.attendance.status === 'delayed') &&
                            <span className='feelColor'> *</span>}
                        </Segment>
                        <Segment className='evaluation-emotional-awareness'>
                            <Rater
                                value={emotionalAwareness}
                                onChangeValue={(value) => { props.onChangeValue('evaluation.emotional_awareness', value.toString()) }}
                                editable={props.editable}
                            />
                        </Segment>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={2} style={{ marginTop: '70px' }}>
                    <Grid.Column>
                        <Segment className='evaluation-question'>
                            {tr('HOW_WOULD_YOU_RATE_PARTICIPANT_COOPERATION')}
                            {(props.session.attendance.status === 'ontime' || props.session.attendance.status === 'delayed') &&
                            <span className='feelColor'> *</span>}
                        </Segment>
                        <Segment className='evaluation-compliance'>
                            <Rater
                                value={compliance}
                                onChangeValue={(value) => { props.onChangeValue('evaluation.compliance', value.toString()) }}
                                editable={props.editable}
                            />
                        </Segment>
                    </Grid.Column>
                    <Grid.Column>
                        <Segment className='evaluation-question'>
                            {tr('WHAT_IS_THE_PROGRESS_TOWARDS_THE_SET_GOAL')}
                            {(props.session.attendance.status === 'ontime' || props.session.attendance.status === 'delayed') &&
                            <span className='feelColor'> *</span>}
                            <Bubble
                                name='info'
                                openImage={openInfo}
                                closedImage={closedInfo}
                                position='bottom center'
                                title={tr('SET_GOAL')}
                                text={props.goal}
                            />
                        </Segment>
                        <Segment className='evaluation-progress'>
                            <Rater
                                value={progress}
                                onChangeValue={(value) => { props.onChangeValue('evaluation.progress', value.toString()) }}
                                editable={props.editable}
                            />
                        </Segment>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={2}>
                    <Grid.Column>
                        <Segment className='evaluation-question'>
                            {tr('IS_PSYCHIATRIST_REFERRAL_NECESSARY')}
                            {(props.session.attendance.status === 'ontime' || props.session.attendance.status === 'delayed') &&
                            <span className='feelColor'> *</span>}
                        </Segment>
                        <Segment className='evaluation-refer-to-psychiatrist'>
                            <Button
                                toggle
                                disabled={!props.editable}
                                active={referToPsychiatrist === true}
                                onClick={
                                    (_e) => {
                                        props.onChangeValue('evaluation.refer_to_psychiatrist', true)
                                    }
                                }
                            >
                                {tr('YES')}
                            </Button>
                            <Button
                                toggle
                                disabled={!props.editable}
                                active={referToPsychiatrist === false}
                                onClick={
                                    (_e) => {
                                        props.onChangeValue('evaluation.refer_to_psychiatrist', false)
                                    }
                                }
                            >
                                {tr('NO')}
                            </Button>
                        </Segment>
                    </Grid.Column>
                    <Grid.Column>
                        <Segment className='evaluation-question'>
                            {tr('ADDITIONAL_NOTES')}
                        </Segment>
                        <Segment className='evaluation-notes'>
                            <TextArea
                                disabled={!props.editable}
                                placeholder={tr('KEEP_HERE_EXTRA_NOTES')}
                                maxLength={300}
                                value={props.session.evaluation ? props.session.evaluation.notes : ''}
                                onChange={(e) => { props.onChangeValue('evaluation.notes', e.target.value) }}
                            />
                        </Segment>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Container>
    )
}

export default Evaluation



// WEBPACK FOOTER //
// ./src/components/participant-session/evaluation.js